import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9ee9c47e")

_pushScopeId("data-v-9ee9c47e")
const _hoisted_1 = { class: "shell padding30px height90per" }
const _hoisted_2 = { class: "display-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "detail-title" }
const _hoisted_4 = { class: "detail-label detail-label-title" }
const _hoisted_5 = { class: "detail-label" }
const _hoisted_6 = { class: "detail-label detail-label-title" }
const _hoisted_7 = { class: "detail-label" }
const _hoisted_8 = { class: "detail-label detail-label-title" }
const _hoisted_9 = { class: "detail-label" }
const _hoisted_10 = { class: "detail-label detail-label-title" }
const _hoisted_11 = { class: "detail-label" }
const _hoisted_12 = { class: "detail-label detail-label-title" }
const _hoisted_13 = { class: "detail-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_update_billing_list = _resolveComponent("update-billing-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextInformation), 1),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _ctx.getUpdateList
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextUpdateBillModel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.TabelResetPwInHtmlAccount) + ":", 1),
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.detail.Account), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextRoleDistributor) + ":", 1),
      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.detail.Manager), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.TabelUserInHtmlCompany) + ":", 1),
      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.detail.Community || '--'), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$wordList.TabelPropertyManageEmail) + ":", 1),
      _createVNode("label", _hoisted_11, _toDisplayString(_ctx.detail.Email || '--'), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$wordList.ProperAllTextMobileNumber) + ":", 1),
      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.detail.Phone || '--'), 1)
    ]),
    (_ctx.showUpdateList)
      ? (_openBlock(), _createBlock(_component_update_billing_list, {
          key: 0,
          initData: _ctx.initData,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showUpdateList=false)),
          onSubmit: _ctx.confirmUpdate
        }, null, 8, ["initData", "onSubmit"]))
      : _createCommentVNode("", true)
  ]))
})